(function () {
  var root = document.querySelector('[data-sup-custom]');
  if (!root) return;

  var playBtn = root.querySelector('[data-video-play]');
  var videoEmbed = root.querySelector('[data-video-embed]');
  if (playBtn && videoEmbed) {
    playBtn.addEventListener('click', function () {
      playBtn.style.display = 'none';
      videoEmbed.hidden = false;
      var iframe = videoEmbed.querySelector('iframe');
      if (iframe && iframe.src.indexOf('autoplay=1') === -1) {
        iframe.src = iframe.src + (iframe.src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
      }
    });
  }

  var faqQuestions = root.querySelectorAll('.faq-question');
  faqQuestions.forEach(function (question) {
    question.addEventListener('click', function () {
      var faqItem = question.parentElement;
      var isActive = faqItem.classList.contains('active');
      root.querySelectorAll('.faq-item').forEach(function (item) {
        item.classList.remove('active');
      });
      if (!isActive) {
        faqItem.classList.add('active');
      }
    });
  });

  var reviewsTrack = root.querySelector('[data-reviews-track]');
  var reviewsPrev = root.querySelector('[data-reviews-prev]');
  var reviewsNext = root.querySelector('[data-reviews-next]');
  if (reviewsTrack && reviewsPrev && reviewsNext) {
    var currentReviewIndex = 0;

    function getVisibleReviewCount() {
      if (window.innerWidth <= 768) return 1;
      if (window.innerWidth <= 1024) return 2;
      return 3;
    }

    function getReviewStep() {
      var firstCard = reviewsTrack.querySelector('.review-card');
      if (!firstCard) return 0;
      var gap = parseInt(window.getComputedStyle(reviewsTrack).gap || '24', 10);
      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateReviewSlider() {
      var cards = reviewsTrack.querySelectorAll('.review-card');
      if (!cards.length) return;

      var visible = getVisibleReviewCount();
      var maxIndex = Math.max(0, cards.length - visible);
      if (currentReviewIndex > maxIndex) {
        currentReviewIndex = maxIndex;
      }

      var offset = getReviewStep() * currentReviewIndex;
      reviewsTrack.style.transform = 'translateX(-' + offset + 'px)';

      reviewsPrev.disabled = currentReviewIndex <= 0;
      reviewsNext.disabled = currentReviewIndex >= maxIndex;
    }

    reviewsPrev.addEventListener('click', function () {
      currentReviewIndex = Math.max(0, currentReviewIndex - 1);
      updateReviewSlider();
    });

    reviewsNext.addEventListener('click', function () {
      var cards = reviewsTrack.querySelectorAll('.review-card');
      var maxIndex = Math.max(0, cards.length - getVisibleReviewCount());
      currentReviewIndex = Math.min(maxIndex, currentReviewIndex + 1);
      updateReviewSlider();
    });

    window.addEventListener('resize', updateReviewSlider);
    updateReviewSlider();
  }

  var stickyBar = root.querySelector('[data-sticky-atc]');
  var stickyForm = root.querySelector('[data-sticky-form]');
  var stickyVariantInput = root.querySelector('[data-sticky-variant-input]');
  var stickyPrice = root.querySelector('[data-sticky-price]');
  if (stickyBar && stickyForm && stickyVariantInput && stickyPrice) {
    var stickyButton = stickyForm.querySelector('button[type="submit"]');
    var variantsNode = root.querySelector('[data-product-variants]');
    var variants = [];

    if (variantsNode) {
      try {
        variants = JSON.parse(variantsNode.textContent || '[]');
      } catch (e) {
        variants = [];
      }
    }

    function formatMoney(cents) {
      var value = Number(cents || 0) / 100;
      var currencyCode = stickyPrice.getAttribute('data-currency-code') || 'EUR';
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: currencyCode
      }).format(value);
    }

    function getVariantById(id) {
      var normalizedId = String(id || '');
      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === normalizedId) return variants[i];
      }
      return null;
    }

    function applyVariant(id) {
      if (!id) return;

      stickyVariantInput.value = id;

      var variant = getVariantById(id);
      if (!variant) return;

      stickyPrice.textContent = formatMoney(variant.price);
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
    }

    function findMainVariantInput() {
      var inputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
      for (var i = 0; i < inputs.length; i += 1) {
        if (!inputs[i].closest('[data-sticky-form]')) return inputs[i];
      }
      return null;
    }

    function syncFromMainForm() {
      var mainInput = findMainVariantInput();
      if (mainInput && mainInput.value) {
        applyVariant(mainInput.value);
      }
    }

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;

      if (target.matches('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]') && !target.closest('[data-sticky-form]')) {
        applyVariant(target.value);
      }
    });

    syncFromMainForm();
  }

})();
